import { useSelector, useDispatch } from 'react-redux';
import { useRouter } from '~/utils/navigation';

import ButtonWrapper from '~/components/misc/button-wrapper.js';

import { Sidebar, SidebarHeader } from '~/components/sidebar/index.js';

import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer.js';
import { ROUTE_ACCOUNT } from '~/components/router/constants.js';
import { showWebPushPrompt } from '../../web-push/ducks/web-push.js';
import { selectWebPushEnabled } from '../../brand/ducks/selectors.js';

import IconButtonClose from '../../misc/icon-button-close.js';

const WebPushBackdoor = () => {
	const dispatch = useDispatch();
	const router = useRouter();
	const transformPath = useContextualPathTransformer();
	const webPushEnabled = useSelector(selectWebPushEnabled);

	const showInHousePrompt = () => {
		if (webPushEnabled) {
			dispatch(showWebPushPrompt(true, `successful-deposit`));
		}
	};

	return (
		<Sidebar>
			<SidebarHeader
				className="sow-custom-header"
				Icon={
					<IconButtonClose
						data-at="flow-navigation-web-push-backdoor"
						className="page-head__close"
						onClick={() => router.push(transformPath(ROUTE_ACCOUNT))}
					/>
				}
			>
				<h2 className="page-head__title" data-at="web-push-backdoor-title">
					Web Push Backdoor
				</h2>
				<div className="page-head__right-side" />
			</SidebarHeader>

			<ButtonWrapper smallerPositionValue="sticky" biggerPositionValue="sticky" webkitSticky>
				<button type="button" className="btn" data-at="web-push-backdoor" onClick={showInHousePrompt}>
					Show Prompt
				</button>
			</ButtonWrapper>
		</Sidebar>
	);
};

export default WebPushBackdoor;
